"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    dataTableModal: {
        fetchingInformation: 'Fetching Information, please wait a second',
        ariaLabel: {
            clickToSort: 'Click to sort.',
            sorting: 'Sort alphabetically in {{order}} order.',
        },
    },
};
